import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
// import HomeIcon from "@mui/icons-material/Home";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import SDOICBG from "../assets/images/new-background.png";

function MainLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  // const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleNavigate = () => {
    navigate("/feedback");
  };

  return (
    <Box
      sx={{
        display: "block",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        // backgroundColor: "lightgray",
        background: `url(${SDOICBG})`,
        backgroundSize: "100vw 100%", // Ensures the background image covers the container
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat", // Prevent repeating
        backgroundAttachment: isDesktop ? "fixed" : "scroll",
        "@media (min-width: 1080px) and (min-height: 1920px)": {
          // Portrait 1080x1920 (for kiosk machines)
          backgroundSize: "130vw 100vh",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        },
        height: "100vh",
        width: "100vw",
        overflow: "auto",
        // overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          width: "0.5rem",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#53FDFD",
        },
      }}
    >
      <Box
        sx={{
          // position: "relative",
          // zIndex: 1,
          height: "4vh",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          mt: isMobile ? 1 : 2,
          pr: isMobile ? 2 : -1,
        }}
      >
        <Tooltip title="Login" sx={{ mr: 5 }}>
          {location?.pathname !== "/feedback" && (
            <IconButton
              onClick={handleNavigate}
              sx={{
                display: { xs: "none", sm: "flex" },
                "@media (max-width: 600px), (min-width: 1080px) and (min-height: 1920px), (min-width: 1921px)":
                  {
                    display: "none",
                  },
              }}
            >
              <AccountCircleSharpIcon
                sx={{
                  fontSize: isMobile ? "30px" : "40px",
                  color: "#000000",
                }}
              />
            </IconButton>
          )}
        </Tooltip>
      </Box>
      <Box
        sx={{
          // position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
          width: "100%",
          minHeight: "100vh",
          padding: isMobile ? 2 : 4,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default MainLayout;
